// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-academia-especialistas-privacidade-js": () => import("./../../../src/pages/academia-especialistas/privacidade.js" /* webpackChunkName: "component---src-pages-academia-especialistas-privacidade-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

